/**
 * Artifacts — the account's files, produced by its collaborations (task 828).
 *
 * The page is deliberately thin: the listing itself is `ArtifactsList`, and this
 * is its one caller. What the page adds is what only a top-level destination
 * needs — a title, and one line saying what an artifact is for a reader who
 * arrived here before ever running a collaboration that made one.
 *
 * This is the only listing of the account's files. Artifacts are what a
 * Collaboration produced, so they are not a tab on an AI Service (task 854);
 * the other place a reader meets one is the card in the collaboration turn that
 * produced it.
 */
import PageHeader from '../components/layout/PageHeader';
import { ArtifactsList } from '../components/artifacts/ArtifactsList';

export default function ArtifactsPage() {
  return (
    <div>
      <PageHeader
        title="Artifacts"
        description="Files your collaborations produced — documents, exports and datasets, each keeping every version."
      />
      <div className="mt-6">
        <ArtifactsList />
      </div>
    </div>
  );
}
